"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignmentMetaGrantsTeacherAccess = exports.DbAssignmentMetaSchema = exports.DbAssignmentStatusSchema = void 0;
const zod_1 = require("zod");
// original at https://github.com/lessonup/lessonup/blob/a3ac598bc65668a5d456f348e2e8ac9ac3eec5b1/libs/lessonup-core/src/domain/assignment/AssignmentMeta.ts
exports.DbAssignmentStatusSchema = zod_1.z.enum(['open', 'closed']);
exports.DbAssignmentMetaSchema = zod_1.z.object({
    _id: zod_1.z.string(),
    assignmentInfo: zod_1.z.object({
        name: zod_1.z.string(),
        numberOfPins: zod_1.z.number(),
        ownerId: zod_1.z.string(),
        pin: zod_1.z.any(),
        subject: zod_1.z.string(),
    }),
    createdAt: zod_1.z.number(),
    lessonId: zod_1.z.string(),
    modifiedAt: zod_1.z.number(),
    ownerId: zod_1.z.string(),
    products: zod_1.z.array(zod_1.z.string()),
    status: exports.DbAssignmentStatusSchema,
    summary: zod_1.z.object({
        dirtyDate: zod_1.z.number(),
        gradedCount: zod_1.z.number(),
        isActive: zod_1.z.boolean(),
        isDirty: zod_1.z.boolean(),
        modifiedAt: zod_1.z.number(),
        numberOfUsers: zod_1.z.number(),
        numberOfUsersSeen: zod_1.z.number(),
        percentagePinsDone: zod_1.z.number(),
        submittedCount: zod_1.z.number(),
    }),
    teacherActivityAt: zod_1.z.number(),
    type: zod_1.z.enum(['realtime', 'test']), // TODO, how to do we want to model different types of assignments?
    usersWithAccess: zod_1.z.array(zod_1.z.string()),
    version: zod_1.z.literal('v2').nullish(),
});
function assignmentMetaGrantsTeacherAccess(userId, meta) {
    return meta.ownerId === userId || meta.usersWithAccess.includes(userId);
}
exports.assignmentMetaGrantsTeacherAccess = assignmentMetaGrantsTeacherAccess;
//# sourceMappingURL=db-assignment-meta.js.map